import React from 'react'
import styles from './index.module.scss'
import { arrowLeft } from '../../../../../assets/svg/dashboard/main'
import { Check } from '../../../../../assets/NewDashboard'
import { FaFileAlt } from "react-icons/fa"
import { useHistory, useParams  } from 'react-router-dom'

const TABS = [
  { id: 'structure', label: 'Соответствие структуре ООП', path: '/dashboard_new/edu_prog/structure/' },
  { id: 'conditions_compliance', label: 'Соответствие условиям реализации', path: '/dashboard_new/conditions_compliance/' },
  { id: 'outcomes_compliance', label: 'Соответствие результатам освоения', path: '/dashboard_new/outcomes_compliance/' },
]

const Header = ({ onBack, accordance, general, activeTab, setActiveTab, title, levelStudy, children }) => {
  
  const history = useHistory();
  const { id } = useParams();

  const handleTabClick = (tabId) => {
    const tabPath = TABS.find((tab) => tab.id === tabId).path;    
    history.push(`${tabPath}${id}`);
  }
  
  return (
    <>
      <div className={styles.header}>
        <div className={styles.backBtn} onClick={onBack}>
          {arrowLeft}
        </div>
        <h2>{title || ''}</h2>
      </div>

      {children}

      <div className={styles.contentWrapper}>
        <div className={styles.leftPanel}>
          <div className={styles.complianceCard}>
            <h3>{TABS.find((tab) => tab.id === activeTab).label}</h3>
            <div className={`${styles.badge} ${accordance ? styles.success : styles.error}`}>
              {accordance ? 'соответствует' : 'не соответствует'}
              <Check mode={accordance ? 'complete' : 'notComplete'} />
            </div>
          </div>

          <div className={styles.fgosCard}>
            <div className={styles.fgosIcon}>
              <FaFileAlt />
            </div>
            <div>
              <div className={styles.fgosTitle}>ФГОС: {title}</div>
              <div className={styles.fgosSubtitle}>{levelStudy}</div>
            </div>
          </div>
        </div>

        <div className={styles.rightPanel}>
          <div className={styles.complianceList}>
            {TABS.map((tab) => (
              <div
                key={tab.id}
                className={`${styles.complianceItem} ${activeTab === tab.id ? styles.active : ''}`}
                onClick={() => handleTabClick(tab.id)}
              >
                <div className={styles.radioCircle}>
                  {activeTab === tab.id && <div className={styles.radioInner} />}
                </div>
                <span>{tab.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default Header
